$eve_app_page_themer $eve_page
	title \Themer
	Head null
	body /
		<= Colors $eve_app_page_themer_colors
